import { render, staticRenderFns } from "./EditSubCertificate.vue?vue&type=template&id=37792016"
import script from "./EditSubCertificate.vue?vue&type=script&lang=js"
export * from "./EditSubCertificate.vue?vue&type=script&lang=js"
import style0 from "./EditSubCertificate.vue?vue&type=style&index=0&id=37792016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports